// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-module--wrapper--ccca2","slider":"carousel-module--slider--58801"};